import LinearProgress from '@mui/material/LinearProgress';
import ErrorPage from '../components/common/ErrorPage';
import TopBar from '../components/common/TopBar';
import TrainingSetTableWrapper from '../components/train/TrainingSetTableWrapper';
import errorResponses from '../errorResponses';
import useSetOrg from '../components/hooks/useSetOrg';
import { useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';

function TrainingPage() {
  const { dpid, id } = useParams<{ dpid: string; id: string }>();
  const { loading, error } = useSetOrg(dpid);
  useSetTitle('Training Sets');

  if (loading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  return (
    <div id="training-page">
      <TopBar />
      <TrainingSetTableWrapper />
    </div>
  );
}
export default TrainingPage;
